<template>
  <aside class="product-card-actions">
    <button v-if="!open" class="product-card-actions-toggle" @click="$emit('open')">
      {{ 'Quick Actions' | t }}
    </button>
    <div v-if="open" class="product-card-actions-panel">
      <ul v-stack-y:xs>
        <slot />
      </ul>
    </div>
  </aside>
</template>

<script>
import t from '../main/i18n';

export default {
  props: {
    open: Boolean
  },
  filters: {
    t
  }
};
</script>

<style lang="scss" scoped>
@import '../../scss/variables';

.product-card-actions {
  display: flex;
  position: absolute;
  right: 1rem;
  bottom: 2rem;
  left: 1rem;
  text-align: center;
  opacity: 0;
  transform: translateY(10px) scale(0.9);
  transition: 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
  transition-property: opacity, transform;

  @media (min-width: $screen-sm) {
    right: 2rem;
    left: 2rem;
  }
}

.product-card-actions-toggle {
  margin-top: auto;
  display: block;
  width: 100%;
  border-radius: 0;
  padding: 1em;
  font: inherit;
  font-weight: 400;
  color: $text-color;
  background-color: #fff;
}

.product-card-actions-toggle::before {
  display: inline-block;
  margin-right: 0.625em;
  transform: scale(1.5);
  content: '\2b';
}

.product-card-actions-panel {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}

.product-card-actions-panel ul {
  margin: 0;
  padding: 0;
  list-style: none;
  transition: opacity 200ms cubic-bezier(0.215, 0.61, 0.355, 1);
}
</style>
